import { MarketingTileList } from 'features/content/components/marketing-tile-group/marketing-tile-list';
import { useWindowDimensions } from 'react-native';

import { IEmptyStateFragment } from 'generated/sanity-graphql';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { spacing } from 'styles/constants';

import {
  Container,
  DescriptionTextBlock,
  HeadingText,
  ImageContainer,
  StyledLoyaltyLogo,
  SubtitleText,
  Terms,
  TitleText,
} from './styled';

export const EmptyStateContent: React.FC<{
  content: IEmptyStateFragment;
  shouldRenderSignUpButton?: boolean;
  bottomInset?: number;
}> = ({ content, shouldRenderSignUpButton = false, bottomInset = 0 }) => {
  const { image, headerText, title, subtitle, description, marketingTileList, terms } = content;
  const mainImage = image?.locale?.app;
  const header = headerText?.locale;
  const titleText = title?.locale;
  const subtitleText = subtitle?.locale;
  const termsText = terms?.locale;
  const descriptionContent = description?.locale;
  const tiles = marketingTileList?.tiles || [];
  const { height: $windowHeight } = useWindowDimensions();
  const isMobile = useIsMobileBreakpoint();

  return (
    <Container
      showsVerticalScrollIndicator={false}
      // Must match ButtonWrapper's total reserved height (ButtonCard's '$20' + bottomInset)
      // so scroll content doesn't render underneath the button. Set via native `style`
      // (not a styled-system prop) since bottomInset is a measured runtime pixel value —
      // UCL Box/ScrollView resolve numeric margin/padding props against the theme scale.
      style={{ marginBottom: shouldRenderSignUpButton ? spacing.$20 + bottomInset : 0 }}
    >
      <StyledLoyaltyLogo
        pictureSize={{
          height: isMobile ? `${spacing.$4}` : `${spacing.$8}`,
          width: '4/5',
        }}
      />
      {header && <HeadingText>{header}</HeadingText>}
      {mainImage && (
        <ImageContainer
          image={mainImage}
          alt={image?.locale?.imageDescription || 'Empty Image'}
          objectFitContain
          $windowHeight={$windowHeight}
        />
      )}
      {titleText && <TitleText>{titleText}</TitleText>}
      {subtitleText && <SubtitleText>{subtitleText}</SubtitleText>}
      {descriptionContent && <DescriptionTextBlock content={descriptionContent} />}
      <MarketingTileList tiles={tiles} />

      {termsText && <Terms content={termsText} />}
    </Container>
  );
};
